import styles from './ArticleImages.module.scss'
import React from 'react'
import Image from 'next/image'
import ImageViewer from '@/components/common/ImageViewer/ImageViewer'

type Props = {
  imageId: number,
  images: number[],
  alt?: string
}

const ArticleImages = (props: Props) => {
  const [openImageId, setOpenImageId] = React.useState<number | undefined>(undefined)

  const imageIds = [
    props?.imageId || 0,
    ...props?.images || [],
  ]

  const openImageViewer = (imageId: number) => {
    setOpenImageId(imageId)
  }

  return (
    <div className={styles.component}>
      <div
        className={styles.primaryImage}
        onClick={() => openImageViewer(props.imageId)}
      >
        {props.imageId && (
          <Image
            src={`${process.env.NEXT_PUBLIC_API}/images/${props.imageId}`}
            alt={props.alt || ''}
            width={216}
            height={216}
            style={{ objectFit: 'contain' }}
          />
        )}
      </div>
      <div className={styles.otherImages}>
        {props.images.map((imageId) => (
          <div
            key={imageId}
            className={styles.image}
            onClick={() => openImageViewer(imageId)}
          >
            <Image
              src={`${process.env.NEXT_PUBLIC_API}/images/${imageId}`}
              alt={props.alt || ''}
              width={51}
              height={51}
              style={{ objectFit: 'contain' }}
            />
          </div>
        ))}
      </div>
      <ImageViewer
        imageIds={imageIds}
        showImageId={openImageId}
        onClose={() => setOpenImageId(undefined)}
      />
    </div>
  )
}

export default ArticleImages